import React, {Component} from 'react';
import Header from "./Header";
import AppNavbar from "./Sidebar";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";
import axios from "axios";


export default class ACHDetailByTerminal extends Component {


    constructor (props) {
        super(props)
        this.state = {
            loggedInUser:null,
            fromDate: '',
            toDate: '',
            terminalId: '',
            disabled : false,
            terminalDetails: []
        };
        this.handleFromDate = this.handleFromDate.bind(this);
        this.handleToTerminalId = this.handleToTerminalId.bind(this);
        this.handleToDate = this.handleToDate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {

                this.setState({ loggedInUser: response.data })
                console.log("=== LOG_1 === Inside componentDidMount %s with data ","ACH Terminal",this.state.loggedInUser);
                //Get Terminal Ids




            }).finally(()=> {
            axios.get('getTerminalByUserId?id='+this.state.loggedInUser)
                .then(response => {
                    this.setState({ terminalDetails: response.data.response,loading: false })
                }).finally(()=> {
            })
                .catch(error => {
                    console.log("Exception Thrown::{ get Terminal details by ID}",error);
                });
        })
            .catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });


    }

    handleFromDate(event) {
        console.log("Changed Value for Date-----",event.target.value)
        this.setState({
            fromDate: event.target.value
        });
    }

    handleToTerminalId(event) {
        console.log("Changed Value for Terminal-----",event.target.value)
        this.setState({
            terminalId: event.target.value
        });
    }

    handleToDate(event) {
        console.log("Changed Value -----",event.target.value)
        this.setState({
            toDate: event.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        console.log(this.state.fromDate,"FromDate ---- ----Todate ------terminalId",this.state.toDate,this.state.terminalId);
        if(this.state.fromDate === '' || this.state.toDate === ''){
            alert(" Please provide valid  Date !!")
            return false;
        }
        if (this.state.disabled) {
            return;
        }
        this.setState({disabled: true});
        axios({
            url: 'downloadAchDetailByTerminalReport?userid='+ this.state.loggedInUser+"&FromDate="+this.state.fromDate+"&ToDate="+this.state.toDate+"&terminalId="+this.state.terminalId, //your url
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ACHDetailByTerminal.xls'); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.setState({disabled: false});
        });
    }

    render() {

        const alignBox = {
            display: "flex",
            justifyContent: "space-around"
        };

        const terminalList = this.state.terminalDetails.map((i) => {
            return <option value={i.terminalId}>{i.terminalId}</option>;
        });
        return (
            <body data-sidebar="colored">
            <div id="layout-wrapper">
                <Header/>
                <AppNavbar data={this.state}/>
            </div>
            <div className="main-content">
                <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
                <MetaTags>
                    <title>DataStream Version 2.0</title>
                    <meta name="description" content="Some description." />
                    <meta property="og:title" content="DataStream Version 2.0" />
                </MetaTags>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Report Management</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-9">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="tab-content p-3 text-muted">
                                            <div className="form-group">
                                                <form onSubmit={ this.handleSubmit }>
                                                    <div className="form-group" style={alignBox}>
                                                        <div>
                                                            <label>From Date: </label>
                                                            <input type="date" id="fromDate" onChange={this.handleFromDate}/>
                                                        </div>
                                                        <div>
                                                            <label>To Date: </label>
                                                            <input type="date" id="toDate" onChange={this.handleToDate}/>
                                                        </div>
                                                        <div>
                                                            <label>TerminalId: </label>
                                                            <select name="terminalId" id="terminalId" onChange={this.handleToTerminalId} >
                                                                {terminalList}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button className="btn btn-primary" onClick={this.handleClick} disabled={this.state.disabled} >Generate Report</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </body>
        );
    }
}